export const apiHost = process.env.API_URL ?? ""
